import { z } from "zod";

import {
  generalMedicalProblemsData,
  specificMedicalProblemsData,
} from "../../../../constants/PatientFormConstants";
import { FormField } from "../../../FormEngine/types";

/**
 * Past Medical History form schema
 *
 * This schema defines the fields for the Past Medical History form
 * using the FormEngine component.
 */
export const pastMedicalHistorySchema: FormField[] = [
  {
    type: "radio",
    name: "hasPaceMaker",
    title: "Do you have a pacemaker?",
    description: "Please select if you have a pacemaker",
    fieldProps: {
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
  },
  {
    type: "multi-select-response",
    name: "generalMedicalProblems",
    title: "General Medical Problems",
    description: "Please list all general medical problems you have had",
    options: generalMedicalProblemsData.map((name) => ({
      value: name,
      label: name,
    })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Description",
      },
    ],
  },
  {
    type: "multi-select-response",
    name: "specificMedicalProblems",
    title: "Specific Medical Problems",
    description: "Please list all specific medical problems you have had",
    options: specificMedicalProblemsData.map((name) => ({
      value: name,
      label: name,
    })),
    schema: [
      {
        type: "radio",
        name: "type",
        fieldProps: {
          options: [
            { label: "Medical", value: "Medical" },
            { label: "Surgical", value: "Surgical" },
          ],
          sx: { backgroundColor: "inherit", flexDirection: "row" },
        },
      },
      {
        type: "input",
        name: "description",
        label: "Description",
      },
    ],
  },
];

export default pastMedicalHistorySchema;
